import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Directive({
  selector: '[appHasRoles]',
  standalone: true
})
export class HasRolesDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set appHasRoles(allowedRoles: string[] | string) {
    const token = sessionStorage.getItem('token');
    if (!token) {
      this.viewContainer.clear();
      return;
    }

    const decoded: any = jwtDecode(token);
    const userRoles: string[] = decoded.authorities || [];

    const rolesToCheck = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
    const hasPermission = userRoles.some(role => rolesToCheck.includes(role));

    this.viewContainer.clear();
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
